import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './components/auth/pre-login/login.component';
import { ConfirmationDialogComponent } from './components/shared/confirmation-dialog/confirmation-dialog.component';
import { DialogService } from './services/dialog.service';
import { OtpVerificationComponent } from './components/auth/otp-verification/otp-verification.component';
import { FormInputComponent } from './components/auth/form-input/form-input.component';
import { LoginsComponent } from './components/auth/logins/logins.component';
import { ForgotpasswordComponent } from './components/auth/forgotpassword/forgotpassword.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { HeaderComponent } from './components/layout/header/header.component';
import { SidebarComponent } from './components/layout/sidebar/sidebar.component';
import { VerifypasswordComponent } from './components/auth/verifypassword/verifypassword.component';
import { OrderListComponent } from './components/admin/order-list/order-list.component';
import { AddOrderComponent } from './components/admin/add-order/add-order.component';
import { MultipleAddOrderComponent } from './components/admin/multiple-add-order/multiple-add-order.component';
import { BulkOrderRowComponent } from './components/admin/multiple-add-order/bulk-order-row/bulk-order-row.component';
import { WarehouseAddComponent } from './components/admin/warehouse-add/warehouse-add.component';
import { WarehouseListComponent } from './components/admin/warehouse-list/warehouse-list.component';
import { DriverListingComponent } from './components/admin/driver-listing/driver-listing.component';
import { AddDriverListingComponent } from './components/admin/add-driver-listing/add-driver-listing.component';
import { SendNotificationComponent } from './components/admin/send-notification/send-notification.component';
import { AddressListingComponent } from './components/admin/address-listing/address-listing.component';
import { AddAddressListingComponent } from './components/admin/add-address-listing/add-address-listing.component';
import { CompaniesListingComponent } from './components/admin/companies-listing/companies-listing.component';
import { ProfileComponent } from './components/admin/profile/profile.component';
import { TicketListingComponent } from './components/admin/ticket-listing/ticket-listing.component';
import { TicketDetailsComponent } from './components/admin/ticket-details/ticket-details.component';
import { SettingsComponent } from './components/admin/settings/settings.component';
import { ArchiveOrderComponent } from './components/admin/archive-order/archive-order.component';
import { LocateDriverComponent } from './components/admin/locate-driver/locate-driver.component';
import { DriverDetailComponent } from './components/admin/driver-detail/driver-detail.component';
import { CreateTicketComponent } from './components/admin/create-ticket/create-ticket.component';
import { OrderDetailComponent } from './components/admin/order-detail/order-detail.component';
import { BetaFeedbackComponent } from './components/admin/beta-feedback/beta-feedback.component';
import { AuthInterceptor } from './shared/auth.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AssignOrderModalComponent } from './components/admin/assign-order-modal/assign-order-modal.component';
import { ActiveDriversComponent } from './components/admin/active-drivers/active-drivers.component';
import { Hr12to24hrPipe } from './hr12to24hr.pipe';
import { ErrormodalComponent } from './components/admin/errormodal/errormodal.component';
import { MatButtonModule } from '@angular/material/button';
import { ToastComponent } from './components/shared/toast/toast.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmExitDialogComponent } from './components/admin/confirm-exit-dialog/confirm-exit-dialog.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { DateAgo } from './pipes/date-ago.pipe';
import { DriverOrderListComponent } from './components/admin/driver-order-list/driver-order-list.component';
import { EditadminComponent } from './components/editadmin/editadmin.component';
import { environment } from '@environments/environment';
import { AngularFirestoreModule } from "@angular/fire/compat/firestore";
import { AngularFireModule } from '@angular/fire/compat';
import { ReusableGoogleMapComponent } from './components/reusable-google-map/reusable-google-map.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { AnalyticsDashboardComponent } from './components/admin/analytics/analytics-dashboard.component';
import { SendNotificationDialogComponent } from './components/send-notification-dialog/send-notification-dialog.component';
import { LocalSpinnerComponent } from './components/shared/local-spinner/local-spinner.component';
import { ReceivingOrdersListingComponent } from './components/receiving-admin/receiving-orders-listing/receiving-orders-listing.component';
import { ReceivingOrderDetailComponent } from './components/receiving-admin/receiving-order-detail/receiving-order-detail.component';
import { DriverSelectComponent } from './components/shared/driver-select/driver-select.component';
import { OfflineScreenComponent } from './components/shared/offline-screen/offline-screen.component';
import { UpdatePlanComponent } from './components/update-plan/update-plan.component';
import { DispatchSheetComponent } from './components/admin/dispatch-sheet/dispatch-sheet.component';

@NgModule({
  declarations: [
    AppComponent,
    DateAgo,
    ConfirmationDialogComponent,
    LoginComponent,
    FormInputComponent,
    OtpVerificationComponent,
    LoginsComponent,
    ForgotpasswordComponent,
    DashboardComponent,
    HeaderComponent,
    SidebarComponent,
    VerifypasswordComponent,
    OrderListComponent,
    AddOrderComponent,
    MultipleAddOrderComponent,
    BulkOrderRowComponent,
    WarehouseAddComponent,
    WarehouseListComponent,
    DriverListingComponent,
    AddDriverListingComponent,
    SendNotificationComponent,
    AddressListingComponent,
    AddAddressListingComponent,
    CompaniesListingComponent,
    ProfileComponent,
    TicketListingComponent,
    TicketDetailsComponent,
    SettingsComponent,
    ArchiveOrderComponent,
    LocateDriverComponent,
    DriverDetailComponent,
    CreateTicketComponent,
    OrderDetailComponent,
    BetaFeedbackComponent,
    AssignOrderModalComponent,
    ActiveDriversComponent,
    Hr12to24hrPipe,
    ErrormodalComponent,
    ToastComponent,
    ConfirmExitDialogComponent,
    DriverOrderListComponent,
    EditadminComponent,
    ReusableGoogleMapComponent,
    AnalyticsDashboardComponent,
    SendNotificationDialogComponent,
    LocalSpinnerComponent,
    ReceivingOrdersListingComponent,
    ReceivingOrderDetailComponent,
    DriverSelectComponent,
    OfflineScreenComponent,
    UpdatePlanComponent,
    DispatchSheetComponent,
  ],
  imports: [
    BrowserModule,
    GoogleMapsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    DragDropModule,
    MatTooltipModule,
    MatDialogModule,
    MatButtonModule,
    MatButtonModule,
    NgxMaterialTimepickerModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
      timeOut: 10000,

    }),
  ],
  providers: [DialogService, Hr12to24hrPipe, {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
  }],
  exports: [
    FormInputComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
